import { render } from "./SettingsTaskCategories.vue?vue&type=template&id=5560bad4&scoped=true"
import script from "./SettingsTaskCategories.vue?vue&type=script&lang=js"
export * from "./SettingsTaskCategories.vue?vue&type=script&lang=js"

import "./SettingsTaskCategories.vue?vue&type=style&index=0&id=5560bad4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5560bad4"]])

export default __exports__